import { CalendarEvent } from "./hooks/useCalendar";

/**
 * Removing the last idea link from a planned event revokes the evidence
 * of the plan (DD-016), so the event reverts to "upcoming".
 *
 * Returns the id of the event to revert, or null when no revert applies
 * (link not found, not an idea link, other idea links remain, or the
 * event is not in "planned").
 */
export function eventToRevertOnUnlink(
  events: CalendarEvent[],
  linkId: string
): string | null {
  const event = events.find((e) => e.links.some((l) => l.id === linkId));
  if (!event || event.status !== "planned") return null;

  const link = event.links.find((l) => l.id === linkId);
  if (!link || link.targetType !== "idea") return null;

  const remainingIdeaLinks = event.links.filter(
    (l) => l.targetType === "idea" && l.id !== linkId
  );
  return remainingIdeaLinks.length === 0 ? event.id : null;
}
